const MAX_ERROR_DETAILS_BYTES = 64 * 1024;

/** Read a bounded clone for telemetry; callers retain the complete response. */
export async function readErrorDetails(response: Response): Promise<unknown> {
  const reader = response.clone().body?.getReader();
  if (!reader) return undefined;

  const bytes = new Uint8Array(MAX_ERROR_DETAILS_BYTES);
  let length = 0;
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        return JSON.parse(new TextDecoder().decode(bytes.subarray(0, length)));
      }
      if (length + value.byteLength > MAX_ERROR_DETAILS_BYTES) return undefined;
      bytes.set(value, length);
      length += value.byteLength;
    }
  } catch {
    return undefined;
  } finally {
    // A cloned stream's cancellation can wait for the original reader. Do not
    // await it: the caller cannot consume that response until this returns.
    void reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}
